<template>
  <div
    class="schedule-grid"
    :style="{ width: gridWidth + 'px', minWidth: gridWidth + 'px' }"
  >
    <div
      v-if="showNowLine && nowLinePosition !== null"
      class="now-line"
      :style="{ top: nowLinePosition + 'px' }"
    ></div>
    <template v-for="(roomEntry, rIdx) in roomsWithEmployees" :key="roomEntry.room.id">
      <ScheduleEmployeeColumn
        v-for="(emp, eIdx) in roomEntry.employees"
        :key="emp.user_id"
        :emp="emp"
        :timeMarks="timeMarks"
        :isLast="isLastColumn(rIdx, eIdx)"
        :colWidth="empColWidth"
        :appointments="appointments"
        :current-date="currentDate"
      />
    </template>
  </div>
</template>

<script>
import ScheduleEmployeeColumn from '@/components/util/calendar/ScheduleEmployeeColumn.vue'

export default {
  name: 'ScheduleGrid',
  components: { ScheduleEmployeeColumn },
  props: {
    roomsWithEmployees: { type: Array, required: true },
    timeMarks: { type: Array, required: true },
    empColWidth: { type: Number, default: 200 },
    appointments: { type: Array, default: () => [] },
    currentDate: { type: String, required: true }
  },
  computed: {
    gridWidth() {
      const count = this.roomsWithEmployees.reduce(
        (sum, room) => sum + room.employees.length, 0
      )
      return count * this.empColWidth
    },
    nowLinePosition() {
      const now = new Date();
      const nowMins = now.getHours() * 60 + now.getMinutes();

      if (nowMins < this.timeMarks[0] || nowMins > this.timeMarks[this.timeMarks.length - 1]) {
        return null; // вне диапазона
      }

      // Находим первый timeMark, который БОЛЬШЕ текущего времени
      let idx = this.timeMarks.findIndex(mins => mins > nowMins);
      if (idx === -1) idx = this.timeMarks.length - 1; // если после всех, ставим в самый низ

      const slotHeight = this.getSlotHeight();

      if (idx === 0) {
        // Текущее время до первой метки (например, раньше старта) — ставим в самый верх
        return 0;
      }

// Предыдущий отрезок
      const prevMark = this.timeMarks[idx - 1];
      const nextMark = this.timeMarks[idx];
      const progress = (nowMins - prevMark) / (nextMark - prevMark); // 0..1, где находимся внутри отрезка

// Позиция = кол-во полных ячеек + доля в следующей
      return (idx - 1 + progress) * slotHeight;
    },
    showNowLine() {
      // Показывать только для сегодняшней даты
      const today = new Date().toISOString().slice(0, 10);
      return this.currentDate === today;
    }
  },
  methods: {
    isLastColumn(rIdx, eIdx) {
      const totalColumns = this.roomsWithEmployees.reduce(
        (sum, room) => sum + room.employees.length, 0
      )
      let idx = 0
      for (let i = 0; i < rIdx; i++) {
        idx += this.roomsWithEmployees[i].employees.length
      }
      idx += eIdx
      return idx === totalColumns - 1
    },
    getSlotHeight() {
      const interval = this.timeMarks[1] - this.timeMarks[0];
      return 32 * (interval / 15); // 32 — базовая высота для 15 минут
    }
  }
}
</script>

<style scoped>
.schedule-grid {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 0;
}
.now-line {
  position: absolute;
  left: 0; right: 0;
  height: 4px;
  background: var(--cal-now-line);
  z-index: 2;
  pointer-events: none;
}
.schedule-grid {
  position: relative; /* Обязательно! */
}
</style>
